<template>
  <section class="news-page" aria-labelledby="news-page-title">
    <router-link to="/#ajankohtaista" class="news-back-link">← Takaisin etusivulle</router-link>
    <header class="news-page-heading">
      <h1 id="news-page-title">Aiemmat uutiset</h1>
      <p>Raviremmin kuulumiset uusimmasta vanhimpaan.</p>
    </header>

    <p class="news-result-count" role="status">{{ articles.length }} uutista<span v-if="articles.length"> · Sivu {{ currentPage }} / {{ pageCount }}</span></p>
    <ol v-if="visible.length" class="news-archive-list">
      <li v-for="article in visible" :key="article.slug" class="news-archive-item">
        <time v-if="article.publishedAt" :datetime="article.publishedAt">{{ formatNewsDate(article.publishedAt) }}</time>
        <span v-else class="news-undated">{{ formatNewsDate(null) }}</span>
        <h2 class="news-archive-title">
          <router-link :to="{ name: 'NewsArticle', params: { slug: article.slug } }">{{ article.title }}</router-link>
        </h2>
      </li>
    </ol>
    <p v-else class="news-empty">Aiemmat uutiset tulevat näkyviin tähän.</p>

    <nav v-if="pageCount > 1" class="news-pagination" aria-label="Aiempien uutisten sivut">
      <router-link v-if="currentPage > 1" :to="listLocation(currentPage - 1)" rel="prev">← Uudemmat</router-link>
      <span v-else></span>
      <span>Sivu {{ currentPage }} / {{ pageCount }}</span>
      <router-link v-if="currentPage < pageCount" :to="listLocation(currentPage + 1)" rel="next">Vanhemmat →</router-link>
      <span v-else></span>
    </nav>
    <div class="news-page-footer">
      <router-link to="/#ajankohtaista" class="news-home-cta">Takaisin etusivulle →</router-link>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { formatNewsDate, getPublishedNews } from '../utils/news';
import { useNewsDate } from '../composables/useNewsDate';

const route = useRoute();
const today = useNewsDate();
const articles = computed(() => getPublishedNews(today.value));
const pageSize = 10;
const pageCount = computed(() => Math.max(1, Math.ceil(articles.value.length / pageSize)));
const currentPage = computed(() => {
  const page = Number(route.query.sivu);
  return Number.isInteger(page) && page > 0 ? Math.min(page, pageCount.value) : 1;
});
const visible = computed(() => articles.value.slice((currentPage.value - 1) * pageSize, currentPage.value * pageSize));
const listLocation = page => ({ name: 'News', query: page > 1 ? { sivu: String(page) } : {} });
</script>

<style src="../styles/news.css"></style>
